import { render, staticRenderFns } from "./addTaskItem.vue?vue&type=template&id=5bc5e030&scoped=true"
import script from "./addTaskItem.vue?vue&type=script&lang=js"
export * from "./addTaskItem.vue?vue&type=script&lang=js"
import style0 from "./addTaskItem.vue?vue&type=style&index=0&id=5bc5e030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5e030",
  null
  
)

export default component.exports